import { IconName, Tag } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

interface AnalyticsMenuProps {
    enterpriseId: string;
    value: string;
}

const AnalyticsReportingMenu = ({ enterpriseId, ...other }: AnalyticsMenuProps) => {
    const canViewSensitiveReports = useCommanderSelector(canCurrentProfileViewSensitiveReports);
    const managerReportEnabled = useFeatureFlag(FeatureFlag.managerReportEnabled);

    return canViewSensitiveReports ? (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.ManagerReport} />}
            primaryText={<LocalizedText textKey={TextKey.ReportPlural} />}
            {...other}
        >
            {createListItemWithLink({
                textKey: TextKey.AvailabilityOccupancyReport,
                iconName: IconName.Availability,
                path: 'MultiPropertyAvailabilityReport/Index',
            })}
            {managerReportEnabled &&
                createListItemWithLink({
                    textKey: TextKey.ManagerReport,
                    iconName: IconName.ManagerReport,
                    path: 'Finance/ManagerReport/Index/$workspaceId',
                    params: { workspaceId: '' }, // TODO: add workspaceId
                    label: (
                        <Tag variant="info">
                            <LocalizedText textKey={TextKey.New} />
                        </Tag>
                    ),
                })}
        </SidebarExpandableListItem>
    ) : null;
};

export default AnalyticsReportingMenu;
